import { useQuery } from '@hooks/reactQuery';

import { getAlreadyPickedDatesForUpdate } from '@api/assetCartRequest';

import { requestCartPickedDatesFormatted } from '@utils/formatter';

import { RENT_REQUESTS_PICKED_DATES_UPDATE } from '@constants/queryKeys';

export const useQueryRentRequestsDatesPickedUpdate = (assetId: string) => {
	const {
		data,
		isLoading: isLoadingDatesPicked,
		isFetching: isFetchingDatesPicked,
	} = useQuery({
		queryKey: [RENT_REQUESTS_PICKED_DATES_UPDATE],
		queryFn: () => getAlreadyPickedDatesForUpdate(assetId),
		select: pickedDates => requestCartPickedDatesFormatted(pickedDates?.dates[0]?.ranges),
		enabled: [!!assetId],
		refetchOnWindowFocus: false,
	});

	return {
		isLoadingRentRequestsDatesPicked: isLoadingDatesPicked || isFetchingDatesPicked,
		rentRequestsDatesPicked: data || [],
	};
};
